"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.valueToArray = void 0;
/**
 * Convert singleton to array if not in an array format
 */
var valueToArray = function (value) { return (Array.isArray(value) ? value : [value]); };
exports.valueToArray = valueToArray;
